import { useMediaQuery } from "react-responsive";

export const mediaQueries = {
    mobile: {
        type: "maxWidth",
        size: 667,
    },
    tablet: {
        type: "maxWidth",
        size: 1023
    },
    largeTablet: {
        type: "maxWidth",
        size: 1200
    },
    desktop: {
        type: "minWidth",
        size: 1200
    }
}

export const screenSizes = [
    {
        'name': 'mobile',
        'minWidth': 0,
        'maxWidth': 667
    },
    {
        'name': 'tablet',
        'minWidth': 668,
        'maxWidth': 1023
    },
    {
        'name': 'largeTablet',
        'minWidth': 1024,
        'maxWidth': 1200
    },
    {
        'name': 'desktop',
        'minWidth': 1201,
        'maxWidth': 9600
    }
]

export const IsMobile = () => {
    const tf = useMediaQuery({maxWidth: 667});
    return tf ? true : false;
}

export const IsTablet = () => {
    const tf = useMediaQuery({maxWidth: 1023, minWidth: 668});
    return tf ? true : false;
}

export const IsLargeTablet = () => {
    const tf = useMediaQuery({maxWidth: 1200, minWidth: 1024});
    return tf ? true : false;
}

export const IsDesktop = () => {
    const tf = useMediaQuery({minWidth: 1201});
    return tf ? true : false;
}


export const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 667 })
    return isMobile ? children : null
}

export const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ maxWidth: 1023, minWidth: 668 })
    return isTablet ? children : null
}

export const LargeTablet = ({ children }) => {
    const isLargeTablet = useMediaQuery({ maxWidth: 1200, minWidth: 1024 })
    return isLargeTablet ? children : null
}

export const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1201 })
    return isDesktop ? children : null
}
